import React from 'react'

import { Loader } from '@driftt/tide-core-legacy'

import UserSelect from 'components/UserSelect'
import SliderMessageBuilder from 'components/shared/MessagePreviews/SliderMessage'

import MessageCta from '../MessageCta'
import Editor from '../Editor'
import Card from '../Card'

import './style.styl'

const TargetedMessageHeader = () => (
  <header className="playbook-title-header">
    <h2>Customize the message your users will see.</h2>
    <p>What do you want to say? Keep it short and sweet, be personal and human!</p>
  </header>
)

export const TargetMessageLoading = () => (
  <div className="playbook-message">
    <TargetedMessageHeader />
    <div className="playbook-message-loading">
      <h3>Loading your playbook</h3>
      <Loader/>
    </div>
  </div>
)

const TargetedMessage = ({
  message,
  onMessageChange,
  headline,
  onHeadlineChange,
  ctaCopy,
  selectedUser,
  onAuthorChange,
  defaultEmbed,
  hideCta,
  headlineInvalid,
}) => {
  return (
    <div className="playbook-message">
      <TargetedMessageHeader />
      <Card title="Targeted Message" description={headline} className="drift-form">
        <SliderMessageBuilder
          hideCta={hideCta}
          widgetContent={{ message, headline, ctaCopy, selectedUser }}
          defaultEmbed={defaultEmbed}
        />
        <div className="playbook-edit-message-heading">Headline</div>
        <input type="text" onChange={onHeadlineChange} value={headline} invalid={headlineInvalid} />
        {headlineInvalid && <div className="playbook-edit-slider-message-invalid--helptext">A slider message needs a headline</div>}
        <div className="playbook-edit-message-heading">Targeted Message Copy</div>
        <Editor value={message} onChange={onMessageChange} />
        <MessageCta />
        <div className="playbook-edit-message-heading">Send From</div>
        <UserSelect selectedUserId={selectedUser ? selectedUser.id : null} onUserIdChange={onAuthorChange} />
      </Card>
    </div>
  )
}
export default TargetedMessage



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetedMessage/component.js